import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateSystemRole($id: String!, $data: updateSystemRoleInput!) {
    updateSystemRole(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateSystemRoleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateSystemRoleInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_role/update_system_role',
  async (
  params: {id: String;data: TYPES.UpdateSystemRoleInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateSystemRole;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateSystemRoleSlice = createSlice({
  name: 'update_system_role',
  initialState: initialState,
  reducers: {
    updateSystemRoleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateSystemRoleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateSystemRoleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateSystemRoleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateSystemRoleClear } = updateSystemRoleSlice.actions;

export const updateSystemRole = createSelector(
  (state: RootState) => state.systemRole.updateSystemRole.result,
  (state: RootState) => state.systemRole.updateSystemRole.error,
  (state: RootState) => state.systemRole.updateSystemRole.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateSystemRoleSlice.reducer;